export default __webpack_public_path__ + "static/Fly2-9f9fe3d3b21eb671427ce5f0363e2f6e.mp3";